// extracted by mini-css-extract-plugin
module.exports = {"button":"Home_button__1CCC1","hamburguerIcon":"Home_hamburguerIcon__20hbK"};